import React, { useState, ReactElement, ComponentType } from "react"
import { Link } from "gatsby"

import "./card.scss"

interface CardHOCProps {
  heading: string
  imgSrc: string
  content: string
  className: string
  activeColor: string
  path: string
  linkLabel?: string
}

interface PassedComponentProps {
  active: boolean
}

type PassedComponentType = ComponentType<PassedComponentProps>

const cardHOC =
  (PassedComponent: PassedComponentType): React.FC<CardHOCProps> =>
  (props) => {
    const {
      heading,
      imgSrc,
      content,
      className,
      activeColor,
      path,
      linkLabel,
      ...restProps
    } = props

    const [hovered, setHovered] = useState(false)

    return (
      <div
        className={hovered ? `card-scaled ${className}` : className}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        {...restProps}
      >
        <div className="card-content-container">
          <div className="card-heading">{heading}</div>
          <div className="card-logo-container">
            <PassedComponent active={hovered} />
          </div>
          <div className="card-picture-wrapper">
            <div
              className="card-picture-background"
              style={{ backgroundColor: hovered ? activeColor : "#707F92" }}
            ></div>
            <div className="card-picture-container">
              <img className="card-picture" src={imgSrc} alt="Student" />
            </div>
          </div>
          <p className="p-lg card-content-text">{content}</p>
        </div>
        <Link className="card-link" to={path}>
          {linkLabel ? linkLabel : "Learn more"}
        </Link>
      </div>
    )
  }

export default cardHOC
